module.exports = __webpack_public_path__ + "img/MoreRangedDamage.e4a51a7f.png";